import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import OptimizedImage from '../common/OptimizedImage';

const Footer = () => {
    const companyInfo = {
        name: "(주)엔터아이티",
        ceo: "최일락",
        businessNumber: "873-87-00767",
        address: "서울특별시 영등포구 여의대방로 65길 12, 903호 에리트빌딩 (우)07333",
        tel: "02-783-3722",
        fax: "02-6455-3723",
        email: "sales@enterit.co.kr",
        copy: "ENTERIT CO., LTD"
    };

    return (
        <footer className="bg-gray-900 text-gray-300">
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
                    <div>
                        <OptimizedImage
                            src="/imgs/company/LOGO.webp"
                            webpSrcSet="/imgs/company/LOGO.webp 1x, /imgs/company/LOGO@2x.webp 2x"
                            alt="ENTER IT"
                            width="268"
                            height="40"
                            className="h-10 w-[268px] mb-6 grayscale invert object-contain"
                        />
                        <p className="text-sm leading-relaxed">
                            (주)엔터아이티는 2017년에 설립된 데이터 보안 및 암호화 전문 IT 솔루션 기업입니다.
                            탈레스(Thales)의 공식 파트너로서 최적의 보안 솔루션을 제공합니다.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-white font-bold mb-6 text-base">Quick Links</h2>
                        <ul className="space-y-3 text-sm">
                            <li><Link to="/about/overview" className="hover:text-blue-400 transition-colors" aria-label="회사 개요 바로가기">회사 개요</Link></li>
                            <li><Link to="/solutions/overview" className="hover:text-blue-400 transition-colors" aria-label="솔루션 바로가기">솔루션</Link></li>
                            <li><Link to="/about/customers" className="hover:text-blue-400 transition-colors" aria-label="주요고객사 바로가기">주요고객사</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <h2 className="text-white font-bold mb-6 text-base">Contact Info</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                            <div className="space-y-4">
                                <div className="flex items-start">
                                    <MapPin size={18} className="mr-3 text-blue-500 mt-0.5" />
                                    <span>{companyInfo.address}</span>
                                </div>
                                <div className="flex items-center">
                                    <Phone size={18} className="mr-3 text-blue-500" />
                                    <span>{companyInfo.tel}</span>
                                </div>
                            </div>
                            <div className="space-y-4">
                                <div className="flex items-center">
                                    <Mail size={18} className="mr-3 text-blue-500" />
                                    <a href={`mailto:${companyInfo.email}`} className="hover:text-blue-400" aria-label={`이메일 보내기: ${companyInfo.email}`}>
                                        {companyInfo.email}
                                    </a>
                                </div>
                                <div className="flex items-center">
                                    <span className="text-blue-400 font-bold mr-3">FAX</span>
                                    <span>{companyInfo.fax}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
                    <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
                        <span>대표 : {companyInfo.ceo}</span>
                        <span>사업자등록번호 : {companyInfo.businessNumber}</span>
                        <Link
                            to="/privacy-policy"
                            className="font-bold text-white hover:text-blue-400 transition-colors"
                            aria-label="개인정보 처리방침 바로가기"
                        >
                            개인정보 처리방침
                        </Link>
                    </div>
                    <p>© {new Date().getFullYear()} {companyInfo.copy}. ALL RIGHTS RESERVED.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
